import { RegisterOptions, UseFormReturn } from 'react-hook-form'
import { FormValues } from './index.context'
import { useTranslation } from 'react-i18next'

export const defaultValues: Partial<FormValues> = {
  dateType: undefined,
  date: [],
  amountFrom: '',
  amountTo: '',
  decisionId: undefined,
  reasonId: undefined,
  paidDate: [],
  secCode: undefined,
  checkStatuses: undefined,
  issuedPayee: undefined,
  checkNumberFrom: '',
  checkNumberTo: '',
}

export const amountMaxLengthWithSeparator = 13
export const amountMaxLengthWithoutSeparator = 10

export const useFormRules = (
  form: UseFormReturn<FormValues>,
): Record<
  keyof FormValues,
  Omit<RegisterOptions<FormValues>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled' | 'value'>
> => {
  const { t } = useTranslation()
  return {
    clientIds: {},
    accountIds: {},
    amountFrom: {},
    amountTo: {
      validate: {
        larger: (value) => {
          const amountFrom = form.getValues('amountFrom')
          if (!amountFrom) {
            return true
          }
          if (amountFrom && value && parseFloat(value as string) < parseFloat(amountFrom)) {
            return t('AllTransactions:validation.larger.amount_to')
          }
          return true
        },
      },
    },
    checkNumberFrom: {},
    checkNumberTo: {
      validate: {
        larger: (value) => {
          const checkNumberFrom = form.getValues('checkNumberFrom')
          if (!checkNumberFrom) {
            return true
          }
          if (checkNumberFrom && value && parseFloat(value as string) < parseFloat(checkNumberFrom)) {
            return t('AllTransactions:validation.larger.check_number_to')
          }
          return true
        },
      },
    },
    checkStatuses: {},
    date: {},
    dateType: {},
    decisionId: {},
    issuedPayee: {},
    paidDate: {},
    reasonId: {},
    secCode: {},
    transactionType: {},
  }
}
